import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money, dateFmt } from "@/lib/api";
import { StatusBadge, UrgencyBadge } from "@/components/StatusBadge";
import { Search, PlusCircle } from "lucide-react";

export default function PortalServices() {
    const [list, setList] = useState([]);
    const [q, setQ] = useState("");

    useEffect(() => {
        const load = async () => {
            try {
                const r = await api.get("/portal/services");
                if (r?.data) setList(r.data);
            } catch (e) { console.warn(e); }
        };
        load();
        const t = setInterval(load, 20000);
        return () => clearInterval(t);
    }, []);

    const filtered = list.filter((s) => {
        if (!q) return true;
        const qq = q.toLowerCase();
        return s.folio?.toLowerCase().includes(qq) || s.patient_name?.toLowerCase().includes(qq);
    });

    return (
        <div className="space-y-4" data-testid="portal-services-page">
            <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 px-3 py-1.5 border border-slate-200 rounded-sm bg-white max-w-md flex-1">
                    <Search className="w-3.5 h-3.5 text-slate-400" strokeWidth={1.5} />
                    <input
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        placeholder="Buscar folio o paciente..."
                        className="bg-transparent outline-none text-sm flex-1"
                    />
                </div>
                <Link to="/portal/request" className="fm-btn-accent">
                    <PlusCircle className="w-3.5 h-3.5" /> Nueva solicitud
                </Link>
            </div>

            <div className="fm-card overflow-hidden">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-200">
                            {["Folio", "Paciente", "Tipo", "Urgencia", "Unidad", "Total", "Estatus", "Fecha"].map((h) => (
                                <th key={h} className="text-left py-2.5 px-3 text-[10px] font-bold text-slate-500 uppercase tracking-wider">{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map((s) => (
                            <tr key={s.id} className="border-b border-slate-100 hover:bg-slate-50">
                                <td className="py-2 px-3">
                                    <Link to={`/portal/services/${s.id}`} className="font-mono text-xs font-bold text-slate-900 hover:text-red-600">{s.folio}</Link>
                                </td>
                                <td className="py-2 px-3 font-medium">{s.patient_name}</td>
                                <td className="py-2 px-3 text-xs">{s.service_type_name}</td>
                                <td className="py-2 px-3"><UrgencyBadge urgency={s.urgency_level} /></td>
                                <td className="py-2 px-3 font-mono text-xs">{s.unit_number || "—"}</td>
                                <td className="py-2 px-3 font-mono text-xs font-bold tabular-nums text-right">{money(s.total)}</td>
                                <td className="py-2 px-3"><StatusBadge status={s.status} /></td>
                                <td className="py-2 px-3 text-xs font-mono text-slate-500">{dateFmt(s.created_at)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {filtered.length === 0 && (
                    <div className="p-10 text-center text-sm text-slate-500">Sin servicios aún. <Link to="/portal/request" className="text-red-600 font-bold underline">Solicitar el primero</Link></div>
                )}
            </div>
        </div>
    );
}
